/*! MYD tracking page */
(function () {
  'use strict';

  var STEP_ORDER = ['booked', 'pickup', 'in_transit', 'ofd', 'delivered'];
  var STATUS_LABEL = {
    placed: 'Order Placed',
    pickup: 'Pending Pickup',
    shipped: 'Shipped',
    in_transit: 'In Transit',
    ofd: 'Out for Delivery',
    ndr: 'Delivery Attempted',
    delivered: 'Delivered',
    rto: 'Returned',
    cancelled: 'Cancelled',
  };
  var BADGE_CLASS = {
    delivered: 's-del',
    rto: 's-rto',
    cancelled: 's-cancel',
    ofd: 's-ndr',
    ndr: 's-ndr',
  };

  function toast(message) {
    var el = document.getElementById('myd-trk-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('on');
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(function () {
      el.classList.remove('on');
    }, 1600);
  }

  function copyText(text) {
    var value = String(text || '').trim();
    if (!value) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(
        function () {
          toast('Copied');
        },
        function () {
          toast('Could not copy');
        }
      );
      return;
    }
    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      toast('Copied');
    } catch (err) {
      toast('Could not copy');
    }
    document.body.removeChild(input);
  }

  function parseBoot() {
    var el = document.getElementById('myd-trk-boot');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function awbFromUrl(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      return (
        parsed.searchParams.get('waybill') ||
        parsed.searchParams.get('awb') ||
        parsed.searchParams.get('tracking_number') ||
        parsed.searchParams.get('wbn') ||
        ''
      );
    } catch (err) {
      return '';
    }
  }

  function classifyStatus(text) {
    var value = String(text || '').toLowerCase();
    if (/cancel/.test(value)) return 'cancelled';
    if (/undelivered|failed delivery|delivery fail|delivery attempted|attempted delivery|could not attempt|\bndr\b/.test(value)) return 'ndr';
    if (/\brto\b|return to origin|returning|\breturned\b/.test(value)) return 'rto';
    if (/scheduled for delivery/.test(value)) return 'in_transit';
    if (/out for delivery|\bofd\b/.test(value)) return 'ofd';
    if (/\bdelivered\b/.test(value) && !/undelivered|failed|out for|scheduled/.test(value)) return 'delivered';
    if (/handed to courier|\bshipped\b|dispatched/.test(value)) return 'shipped';
    if (/transit|hub|inscan|outscan|reached|departed/.test(value)) return 'in_transit';
    if (/pickup|picked|manifest|booked|order placed|awb/.test(value)) return 'pickup';
    return '';
  }

  function titleCase(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/\b([a-z])/g, function (match) {
        return match.toUpperCase();
      });
  }

  function kindFromStatus(status) {
    if (status === 'delivered') return 'del';
    if (status === 'ofd') return 'ofd';
    if (status === 'ndr') return 'ndr';
    if (status === 'in_transit' || status === 'shipped') return 'hub';
    if (status === 'rto' || status === 'cancelled') return 'rto';
    return '';
  }

  function parseTrackDate(value) {
    if (!value && value !== 0) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    if (typeof value === 'number') {
      var fromNum = new Date(value);
      return Number.isNaN(fromNum.getTime()) ? null : fromNum;
    }
    var raw = String(value).trim();
    if (!raw || raw === 'null') return null;
    var ruby = raw.match(/^(\d+),(\d+),(\d+),(\d+),(\d+),(\d+)/);
    if (ruby) {
      var fromRuby = new Date(
        Number(ruby[6]),
        Number(ruby[5]) - 1,
        Number(ruby[4]),
        Number(ruby[3]),
        Number(ruby[2]),
        Number(ruby[1])
      );
      return Number.isNaN(fromRuby.getTime()) ? null : fromRuby;
    }
    var fromRaw = new Date(raw);
    return Number.isNaN(fromRaw.getTime()) ? null : fromRaw;
  }

  function formatTime(value) {
    var date = parseTrackDate(value);
    if (!date) return '';
    var day = date.getDate();
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var timeStr = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
    return day + ' ' + month + ' ' + year + ', ' + timeStr;
  }

  function formatHeroDate(value) {
    if (!value) return '';
    var date = parseTrackDate(value);
    if (!date) return '';
    var weekday = date.toLocaleDateString('en-IN', { weekday: 'long' });
    var month = date.toLocaleDateString('en-IN', { month: 'long' });
    var year = date.getFullYear();
    return weekday + ', ' + month + ' <b>' + date.getDate() + '</b> ' + year;
  }

  function formatEdd(value) {
    var raw = String(value || '').trim();
    if (!raw || raw === 'null' || raw === '{}') return '';
    var date;
    var ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) {
      date = new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
    } else {
      date = new Date(raw);
    }
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  function applyExpectedDelivery(value, status) {
    var row = document.getElementById('myd-trk-edd-row');
    var el = document.getElementById('myd-trk-edd');
    if (!row || !el) return;
    if (status !== 'shipped' && status !== 'in_transit' && status !== 'ofd') {
      row.hidden = true;
      return;
    }
    var text = formatEdd(value);
    if (!text) {
      row.hidden = true;
      return;
    }
    el.textContent = text;
    row.hidden = false;
  }

  function formatCalDate(value) {
    if (!value) return null;
    var date = parseTrackDate(value);
    if (!date) return null;
    return {
      month: date.toLocaleDateString('en-US', { month: 'long' }).toUpperCase() + ' ' + date.getFullYear(),
      num: String(date.getDate()),
      day: date.toLocaleDateString('en-US', { weekday: 'long' }),
    };
  }

  function courierLogoUrl(name, logos) {
    var n = String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!n || !logos) return '';
    if (n.indexOf('bluedart') !== -1 || (n.indexOf('blue') !== -1 && n.indexOf('dart') !== -1)) return logos.bluedart || '';
    if (n.indexOf('delhivery') !== -1) return logos.delhivery || '';
    if (n.indexOf('xpressbees') !== -1) return logos.xpressbees || '';
    if (n.indexOf('dtdc') !== -1) return logos.dtdc || '';
    if (n.indexOf('ekart') !== -1) return logos.ekart || '';
    return '';
  }

  function applyCourierLogo(name) {
    var boot = parseBoot() || {};
    var src = courierLogoUrl(name, boot.courierLogos);
    var img = document.getElementById('myd-trk-courier-logo');
    var icon = document.getElementById('myd-trk-courier-icon');
    if (img && src) {
      img.src = src;
      img.alt = name;
      img.hidden = false;
      if (icon) icon.hidden = true;
    } else if (img && !src) {
      img.removeAttribute('src');
      img.hidden = true;
      if (icon) icon.hidden = false;
    }
  }

  function setLive(state, message) {
    var el = document.getElementById('myd-trk-live');
    if (!el) return;
    el.hidden = false;
    el.setAttribute('data-state', state);
    el.textContent = message;
  }

  function applyStatus(status, updatedAt, courier) {
    var badge = document.getElementById('myd-trk-badge');
    var label = document.getElementById('myd-trk-badge-label');
    var dateEl = document.getElementById('myd-trk-date');
    var courierEl = document.getElementById('myd-trk-courier-label');
    var fill = document.getElementById('myd-trk-step-fill');
    var stepper = document.getElementById('myd-trk-stepper');

    if (label) label.textContent = STATUS_LABEL[status] || status;
    var calTag = document.getElementById('myd-trk-cal-tag');
    if (calTag) calTag.textContent = STATUS_LABEL[status] || status;
    if (badge) {
      badge.className = 'status-badge' + (BADGE_CLASS[status] ? ' ' + BADGE_CLASS[status] : '');
    }
    if (dateEl && updatedAt) {
      var hero = formatHeroDate(updatedAt);
      if (hero) dateEl.innerHTML = hero;
    }
    var cal = formatCalDate(updatedAt);
    if (cal) {
      var calMonth = document.getElementById('myd-trk-cal-month');
      var calNum = document.getElementById('myd-trk-cal-num');
      var calDay = document.getElementById('myd-trk-cal-day');
      if (calMonth) calMonth.textContent = cal.month;
      if (calNum) calNum.textContent = cal.num;
      if (calDay) calDay.textContent = cal.day;
    }
    if (courierEl && courier) courierEl.textContent = courier;
    applyCourierLogo(courier || '');

    var fillWidth = '0%';
    if (status === 'delivered' || status === 'rto') fillWidth = '100%';
    else if (status === 'ofd') fillWidth = '75%';
    else if (status === 'in_transit' || status === 'shipped') fillWidth = '50%';
    else if (status === 'pickup') fillWidth = '25%';
    if (fill) fill.style.width = fillWidth;

    if (!stepper) return;
    var currentIndex = STEP_ORDER.indexOf(status === 'shipped' ? 'in_transit' : status === 'ofd' ? 'ofd' : status);
    if (status === 'rto') currentIndex = STEP_ORDER.length - 1;
    stepper.querySelectorAll('[data-step]').forEach(function (step) {
      var key = step.getAttribute('data-step');
      var index = STEP_ORDER.indexOf(key);
      var lbl = step.querySelector('.st-lbl');
      step.classList.remove('now', 'done', 'rto', 'cancel');
      if (status === 'cancelled' && key === 'delivered') {
        step.classList.add('cancel');
        if (lbl) lbl.textContent = 'Cancelled';
      } else if (status === 'rto' && key === 'delivered') {
        step.classList.add('rto');
        if (lbl) lbl.textContent = 'Returned';
      } else if (key === 'delivered' && lbl) {
        lbl.textContent = 'Delivered';
      }
      if (index === currentIndex && status !== 'cancelled' && status !== 'rto') {
        step.classList.add('now');
      } else if (index < currentIndex) {
        step.classList.add('done');
      }
    });
  }

  function renderEvents(events) {
    var root = document.getElementById('myd-trk-timeline');
    if (!root || !events.length) return;
    root.innerHTML = events
      .map(function (event, index) {
        var kind = event.kind ? ' tl-' + event.kind : '';
        var first = index === 0 ? ' tl-first' : '';
        var time = event.time ? '<div class="tl-time">' + escapeHtml(formatTime(event.time)) + '</div>' : '';
        var loc = event.loc
          ? '<div class="tl-loc"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" /><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" /></svg>' +
            escapeHtml(event.loc) +
            '</div>'
          : '';
        var msg = event.msg && event.msg.toLowerCase() !== String(event.act || '').toLowerCase() ? '<div class="tl-msg">' + escapeHtml(event.msg) + '</div>' : '';
        var pending = event.pending ? ' tl-pending' : '';
        return (
          '<div class="tl-item' +
          first +
          kind +
          pending +
          '"><span class="tl-dot" aria-hidden="true"></span><div class="tl-body"><div class="tl-act">' +
          escapeHtml(event.act) +
          '</div>' +
          time +
          loc +
          msg +
          '</div></div>'
        );
      })
      .join('');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function asList(value) {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  function pick(obj, keys) {
    if (!obj) return '';
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      if (obj[key] != null && obj[key] !== '') return obj[key];
    }
    return '';
  }

  function normalizeScan(scan) {
    var detail = scan.ScanDetail || scan.scan_detail || scan;
    var bucket = pick(detail, ['clickpost_status_bucket_description', 'clickpost_status_description']);
    var msg = pick(detail, ['remark', 'Remarks', 'Scan', 'scan', 'message']);
    var rawStatus = pick(detail, ['status', 'Status']);
    if (!msg) msg = rawStatus;
    var act = rawStatus || bucket || pick(detail, ['Scan', 'scan']) || msg;
    var loc = pick(detail, ['ScannedLocation', 'location', 'Location', 'hub', 'city']);
    var time = pick(detail, [
      'ScanDateTime',
      'scan_datetime',
      'timestamp',
      'time',
      'StatusDateTime',
      'updated_at',
      'created_at',
    ]);
    var status = classifyStatus(act) || classifyStatus(bucket) || classifyStatus(msg);
    return {
      act: String(act || 'update').toLowerCase(),
      msg: msg && msg !== act ? msg : '',
      loc: loc,
      time: time,
      kind: kindFromStatus(status),
      status: status,
    };
  }

  function normalizePayload(data) {
    if (!data || typeof data !== 'object') return null;
    var shipment =
      data.shipment ||
      (data.data && data.data.shipment) ||
      (Array.isArray(data.data) && data.data[0] && (data.data[0].Shipment || data.data[0].shipment)) ||
      data.result ||
      data.tracking ||
      data;
    var scans = shipment.scans || shipment.Scans || shipment.scan || shipment.history || shipment.checkpoints || [];
    if (scans.ScanDetail) scans = [scans];
    scans = asList(scans)
      .map(normalizeScan)
      .filter(function (item) {
        return item.msg || item.act;
      });
    var latest = shipment.Status || shipment.status || shipment.latest_status || {};
    var statusText = pick(latest, ['Status', 'status', 'latest_status', 'clickpost_status']) || (scans[0] && scans[0].msg);
    var status = classifyStatus(statusText) || (scans[0] && scans[0].status);
    if (!status && !scans.length) return null;
    if (scans.length && !classifyStatus(scans[0].act) && status) {
      scans[0].status = status;
      scans[0].kind = kindFromStatus(status);
      scans[0].act = status.replace(/_/g, ' ');
    }
    var extra = shipment.additional || shipment.Additional || {};
    return {
      status: status || 'in_transit',
      courier: pick(shipment, ['courier', 'Courier', 'cp_name', 'CarrierName']) || pick(latest, ['StatusLocation']),
      updatedAt: pick(latest, ['StatusDateTime', 'updated_at']) || (scans[0] && scans[0].time),
      expectedDelivery:
        pick(shipment, ['expected_delivery', 'expectedDelivery', 'courier_partner_edd', 'ExpectedDeliveryDate']) ||
        pick(latest, ['expected_delivery_date', 'expected_delivery', 'ExpectedDeliveryDate']) ||
        pick(extra, ['courier_partner_edd', 'expected_delivery_date']),
      events: scans,
    };
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function (res) {
      if (!res.ok) throw new Error('bad status');
      return res.json();
    });
  }

  function normalizeClickpost(payload, awb) {
    var tracking = payload && payload.tracking;
    if (tracking && Array.isArray(tracking.history) && tracking.history.length) {
      var events = tracking.history
        .map(normalizeScan)
        .filter(function (item) {
          return item.msg || item.act;
        })
        .sort(function (a, b) {
          return new Date(b.time || 0).getTime() - new Date(a.time || 0).getTime();
        });
      return {
        status: classifyStatus(tracking.status) || (events[0] && events[0].status) || 'in_transit',
        courier: tracking.courier || '',
        updatedAt: events[0] && events[0].time,
        expectedDelivery: tracking.expected_delivery || tracking.expectedDelivery || '',
        events: events,
      };
    }
    return normalizePayload(payload, awb);
  }

  function tryClickpost(boot) {
    var awb = String(boot.awb || awbFromUrl(boot.trackingUrl) || '').trim();
    var orderNum = String(boot.orderNum || '').replace('#', '').trim();
    var api = String(boot.trackApi || 'https://z01mbz6pjg.execute-api.ap-south-1.amazonaws.com/track').trim();
    if (!awb || !orderNum) return Promise.reject(new Error('no awb'));
    var url = api + (api.indexOf('?') === -1 ? '?' : '&');
    if (awb) url += 'awb=' + encodeURIComponent(awb) + '&';
    if (orderNum) url += 'order=' + encodeURIComponent(orderNum) + '&';
    if (boot.courier) url += 'courier=' + encodeURIComponent(boot.courier);
    return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function (res) {
      if (!res.ok) throw new Error('bad status');
      return res.json();
    }).then(function (data) {
      var parsed = normalizeClickpost(data, awb);
      if (!parsed || !parsed.events || !parsed.events.length) throw new Error('empty');
      return parsed;
    });
  }

  function tryLive(boot) {
    var awb = String(boot.awb || awbFromUrl(boot.trackingUrl) || '').trim();
    var urls = awb
      ? [
          'https://dlv-web-api.delhivery.com/v3/unified-tracking?wbn=' + encodeURIComponent(awb),
        ]
      : [];

    var chain = tryClickpost(boot);
    urls.forEach(function (url) {
      chain = chain.catch(function () {
        return fetchJson(url).then(normalizePayload).then(function (parsed) {
          if (!parsed) throw new Error('empty');
          return parsed;
        });
      });
    });
    return chain;
  }

  function pickEventByStatus(events, status) {
    for (var i = 0; i < events.length; i += 1) {
      if (events[i].status === status) return events[i];
    }
    return null;
  }

  function hasPlacedEvent(events) {
    return events.some(function (event) {
      return event.status === 'placed' || /order placed|booked/.test(String(event.act || '').toLowerCase());
    });
  }

  function appendOrderPlaced(events, boot) {
    if (hasPlacedEvent(events) || !boot.placedAt) return events;
    events.push({
      act: 'order placed',
      msg: 'Order placed',
      loc: boot.origin || '',
      time: boot.placedAt,
      kind: '',
      status: 'placed',
    });
    return events;
  }

  function hasRichCourierHistory(events) {
    var hub = events.filter(function (event) {
      return event.status && event.status !== 'placed';
    });
    var times = {};
    hub.forEach(function (event) {
      if (event.time) times[String(event.time)] = true;
    });
    return hub.length >= 3 || Object.keys(times).length >= 3;
  }

  function simplifyEvents(events, boot, status) {
    var rawEvents = (events || []).slice();
    var currentStatus = status || 'placed';
    var rankMap = { placed: 0, pickup: 1, shipped: 2, in_transit: 3, ofd: 4, delivered: 5, rto: 5, cancelled: 5 };
    var currentRank = rankMap[currentStatus] || 0;

    var sorted = rawEvents.sort(function (a, b) {
      var tA = parseTrackDate(a.time) ? parseTrackDate(a.time).getTime() : 0;
      var tB = parseTrackDate(b.time) ? parseTrackDate(b.time).getTime() : 0;
      return tB - tA;
    });

    var rtoScan = pickEventByStatus(sorted, 'rto');
    var ndrScan = pickEventByStatus(sorted, 'ndr');
    var delScan = pickEventByStatus(sorted, 'delivered');
    var ofdScan = pickEventByStatus(sorted, 'ofd');
    var transitScan = pickEventByStatus(sorted, 'in_transit');
    var shippedScan = pickEventByStatus(sorted, 'shipped') || pickEventByStatus(sorted, 'pickup');

    var result = [];

    // 1. Terminal / Final stage:
    if (currentStatus === 'rto' || rtoScan) {
      result.push({
        act: 'Returned',
        loc: (rtoScan && rtoScan.loc) || (sorted[0] && sorted[0].loc) || boot.origin || '',
        time: (rtoScan && rtoScan.time) || (sorted[0] && sorted[0].time) || '',
        kind: 'rto',
        status: 'rto',
      });
    } else if (currentStatus === 'delivered' || delScan) {
      result.push({
        act: 'Delivered',
        loc: (delScan && delScan.loc) || (sorted[0] && sorted[0].loc) || boot.shipTo || '',
        time: (delScan && delScan.time) || (sorted[0] && sorted[0].time) || '',
        kind: 'del',
        status: 'delivered',
      });
    }

    // 2. Failed delivery / NDR (if occurred)
    if (ndrScan) {
      result.push({
        act: 'Failed delivery',
        loc: ndrScan.loc || (ofdScan && ofdScan.loc) || boot.shipTo || '',
        time: ndrScan.time,
        kind: 'ndr',
        status: 'ndr',
      });
    }

    // 3. Out for delivery (if reached rank 4 or scanned)
    if (currentRank >= 4 || ofdScan) {
      result.push({
        act: 'Out for delivery',
        loc: (ofdScan && ofdScan.loc) || (delScan && delScan.loc) || boot.shipTo || '',
        time: (ofdScan && ofdScan.time) || '',
        kind: 'ofd',
        status: 'ofd',
      });
    }

    // 4. In transit (if reached rank 3 or scanned)
    if (currentRank >= 3 || transitScan) {
      result.push({
        act: 'In transit',
        loc: (transitScan && transitScan.loc) || boot.origin || '',
        time: (transitScan && transitScan.time) || '',
        kind: 'hub',
        status: 'in_transit',
      });
    }

    // 5. Shipped (if reached rank 2 or scanned or boot shipped date)
    if (currentRank >= 2 || shippedScan || boot.shippedAt) {
      result.push({
        act: 'Shipped',
        loc: (shippedScan && shippedScan.loc) || boot.origin || '',
        time: (shippedScan && shippedScan.time) || boot.shippedAt || '',
        kind: 'hub',
        status: 'shipped',
      });
    }

    // 6. Order placed
    var placedTime = boot.placedAt || (sorted.length ? sorted[sorted.length - 1].time : '');
    var placedLoc = boot.origin || (sorted.length ? sorted[sorted.length - 1].loc : '');
    result.push({
      act: 'Order placed',
      loc: placedLoc,
      time: placedTime,
      kind: '',
      status: 'placed',
    });

    return result;
  }

  function buildProgressEvents(boot, live) {
    var courier = (live.events || []).slice();
    var status = live.status || 'placed';
    return simplifyEvents(courier, boot, status);
  }

  function isInFlight(status) {
    return status === 'pickup' || status === 'shipped' || status === 'in_transit' || status === 'ofd';
  }

  function applyLive(boot, live) {
    var calDate = isInFlight(live.status) && live.expectedDelivery ? live.expectedDelivery : live.updatedAt;
    applyStatus(live.status, calDate, live.courier || boot.courier);
    if (isInFlight(live.status) && live.expectedDelivery) {
      var calTag = document.getElementById('myd-trk-cal-tag');
      if (calTag) calTag.textContent = 'Expected';
    }
    applyExpectedDelivery(live.expectedDelivery, live.status);
    if (!live.events || !live.events.length) return;
    renderEvents(buildProgressEvents(boot, live));
  }

  function revealCal() {
    var cal = document.getElementById('myd-trk-cal');
    if (cal) cal.classList.remove('is-loading');
  }

  function applyShopifyFallback(boot) {
    if (boot.cancelled) {
      applyStatus('cancelled', boot.placedAt, boot.courier);
      setLive('order', 'Showing latest updates from your order');
      return;
    }
    if (boot.deliveredAt) {
      applyStatus('delivered', boot.deliveredAt, boot.courier);
      var tag = document.getElementById('myd-trk-cal-tag');
      if (tag && boot.isPos) tag.textContent = 'Picked up';
      setLive('order', 'Showing Shopify delivery date');
      return;
    }
    if (boot.shippedAt) {
      applyStatus('in_transit', boot.shippedAt, boot.courier);
      setLive('order', 'Showing shipment date');
      return;
    }
    applyStatus('placed', boot.placedAt, boot.courier);
    setLive('order', 'Showing order placed date');
  }

  function initLive() {
    var boot = parseBoot();
    if (!boot) {
      revealCal();
      return;
    }
    setLive('loading', 'Fetching live shipment data…');
    tryLive(boot).then(
      function (live) {
        applyLive(boot, live);
        revealCal();
        setLive('live', 'Live courier updates');
      },
      function () {
        applyShopifyFallback(boot);
        revealCal();
      }
    );
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-myd-track-copy]');
    if (!btn) return;
    event.preventDefault();
    copyText(btn.getAttribute('data-myd-track-copy'));
  });

  document.addEventListener('change', function (event) {
    var pick = event.target && event.target.closest && event.target.closest('[data-myd-track-order-pick]');
    if (!pick || !pick.value) return;
    window.location.assign(pick.value);
  });

  function normKey(value) {
    return String(value || '')
      .replace(/[#\s]/g, '')
      .toLowerCase();
  }

  function loadOrderCatalog() {
    var el = document.getElementById('myd-trk-orders');
    if (!el) return [];
    try {
      var rows = JSON.parse(el.textContent);
      return Array.isArray(rows) ? rows : [];
    } catch (err) {
      return [];
    }
  }

  function findOrderRow(catalog, orderValue) {
    var key = normKey(orderValue);
    if (!key) return null;
    for (var i = 0; i < catalog.length; i += 1) {
      var keys = catalog[i].keys || [];
      for (var k = 0; k < keys.length; k += 1) {
        if (normKey(keys[k]) === key) return catalog[i];
      }
    }
    return null;
  }

  function findAwbRow(catalog, awbValue) {
    var key = normKey(awbValue);
    if (!key) return null;
    for (var i = 0; i < catalog.length; i += 1) {
      var awbs = catalog[i].awbs || [];
      for (var a = 0; a < awbs.length; a += 1) {
        if (normKey(awbs[a]) === key) return catalog[i];
      }
    }
    return null;
  }

  function setFieldError(input, msgEl, message) {
    var wrap = input && input.closest ? input.closest('.fg') : null;
    if (wrap) wrap.classList.toggle('is-error', Boolean(message));
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (!msgEl) return;
    if (message) {
      msgEl.hidden = false;
      msgEl.textContent = message;
    } else {
      msgEl.hidden = true;
      msgEl.textContent = '';
    }
  }

  function initTrackForm() {
    var form = document.querySelector('[data-myd-track-form]');
    if (!form) return;
    var catalog = loadOrderCatalog();
    var orderInput = form.querySelector('[data-trk-order]');
    var awbInput = form.querySelector('[data-trk-awb]');
    var orderMsg = form.querySelector('[data-trk-order-msg]');
    var awbMsg = form.querySelector('[data-trk-awb-msg]');
    var formError = form.querySelector('[data-trk-form-error]');

    function validate() {
      var orderValue = orderInput ? String(orderInput.value || '').trim() : '';
      var awbValue = awbInput ? String(awbInput.value || '').trim() : '';
      var orderRow = findOrderRow(catalog, orderValue);
      var awbRow = findAwbRow(catalog, awbValue);
      var orderErr = '';
      var awbErr = '';
      var topErr = '';

      if (!orderValue && !awbValue) {
        topErr = 'Enter an order number or AWB from your account.';
      } else {
        if (orderValue && !orderRow) {
          orderErr = 'This order is not on your account.';
        }
        if (awbValue && !awbRow) {
          awbErr = 'This AWB is not on your account.';
        }
        if (orderRow && awbValue && awbRow && orderRow !== awbRow) {
          awbErr = 'This AWB does not belong to that order.';
        }
        if (orderValue && !orderErr && awbValue && !awbRow && !awbErr) {
          awbErr = 'This AWB is not on your account.';
        }
      }

      setFieldError(orderInput, orderMsg, orderErr);
      setFieldError(awbInput, awbMsg, awbErr);
      if (formError) {
        if (topErr) {
          formError.hidden = false;
          formError.textContent = topErr;
        } else {
          formError.hidden = true;
          formError.textContent = '';
        }
      }
      return !topErr && !orderErr && !awbErr;
    }

    form.addEventListener('submit', function (event) {
      if (!validate()) {
        event.preventDefault();
        var first = form.querySelector('.fg.is-error input') || orderInput;
        if (first && first.focus) first.focus();
        return;
      }
      var orderValue = orderInput ? String(orderInput.value || '').trim() : '';
      var awbValue = awbInput ? String(awbInput.value || '').trim() : '';
      var row = findOrderRow(catalog, orderValue) || findAwbRow(catalog, awbValue);
      if (row && orderInput && !orderValue && row.keys && row.keys[1]) {
        orderInput.value = String(row.keys[1]);
      }
      if (row && awbInput && !awbValue && row.awbs && row.awbs[0]) {
        awbInput.value = String(row.awbs[0]);
      }
    });
    function onBlur(input, msgEl) {
      return function () {
        if (String(input.value || '').trim()) {
          validate();
          return;
        }
        setFieldError(input, msgEl, '');
        if (formError && !String((orderInput && orderInput.value) || '').trim() && !String((awbInput && awbInput.value) || '').trim()) {
          formError.hidden = true;
          formError.textContent = '';
        }
      };
    }
    if (orderInput) orderInput.addEventListener('blur', onBlur(orderInput, orderMsg));
    if (awbInput) awbInput.addEventListener('blur', onBlur(awbInput, awbMsg));
  }

  function initPickPager() {
    var list = document.querySelector('[data-trk-pick-pages]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-trk-pick-item]'));
    var pager = document.querySelector('[data-trk-pick-pager]');
    var pageSize = parseInt(list.getAttribute('data-page-size'), 10) || 5;
    var page = 0;
    var pages = Math.max(1, Math.ceil(items.length / pageSize));

    function render() {
      var start = page * pageSize;
      var end = start + pageSize;
      items.forEach(function (el, i) {
        el.hidden = i < start || i >= end;
      });
      if (!pager) return;
      var prev = pager.querySelector('[data-trk-pick-prev]');
      var next = pager.querySelector('[data-trk-pick-next]');
      var status = pager.querySelector('[data-trk-pick-status]');
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= pages - 1;
      if (status) status.textContent = page + 1 + ' / ' + pages;
    }

    if (pager) {
      pager.addEventListener('click', function (event) {
        if (event.target.closest('[data-trk-pick-prev]') && page > 0) {
          page -= 1;
          render();
        } else if (event.target.closest('[data-trk-pick-next]') && page < pages - 1) {
          page += 1;
          render();
        }
      });
    }

    render();
  }

  function boot() {
    initPickPager();
    initTrackForm();
    initLive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
